import { accountUtils } from '@/utils/account';

// Define dataLayer type for TypeScript
declare global {
  interface Window {
    dataLayer: any[];
  }
}

export default {
  async install(app: any, options: {gtmIds: string[], store?: any}): Promise<void> {
    const { gtmIds, store } = options;
    const ids = gtmIds.filter(id => id);
    if (!ids.length) {
      return;
    }

    // Initialize dataLayer
    window.dataLayer = window.dataLayer || [];

    if (store) {
      let storeCareerID = store.getters['careerId/careerId'];
      if (!storeCareerID) {
        try {
          if (accountUtils.isLogin()) {
            await store.dispatch('careerId/receive');
            storeCareerID = store.getters['careerId/careerId'];
            if (storeCareerID) {
              window.dataLayer.push({
                career_id: storeCareerID
              });
            }
          }
        } catch (err) {
          console.warn(err);
        }
      } else {
        window.dataLayer.push({
          career_id: storeCareerID
        });
      }
    }
    window.dataLayer.push({
      'gtm.start': new Date().getTime(),
      event: 'gtm.js'
    });

    // Add GTM script for each ID
    ids.forEach(id => {
      // Add script tag to head
      const script = document.createElement('script');

      script.innerHTML = `
        (function(w,d,s,l,i){w[l]=w[l]||[];w[l].push({'gtm.start':
        new Date().getTime(),event:'gtm.js'});var f=d.getElementsByTagName(s)[0],
        j=d.createElement(s),dl=l!='dataLayer'?'&l='+l:'';j.async=true;j.src=
        'https://www.googletagmanager.com/gtm.js?id='+i+dl;f.parentNode.insertBefore(j,f);
        })(window,document,'script','dataLayer','${id}');
      `;

      document.head.appendChild(script);

      // Add noscript iframe
      const noscript = document.createElement('noscript');
      const iframe = document.createElement('iframe');

      iframe.src = `https://www.googletagmanager.com/ns.html?id=${id}`;
      iframe.height = '0';
      iframe.width = '0';
      iframe.style.display = 'none';
      iframe.style.visibility = 'hidden';

      noscript.appendChild(iframe);

      // Wait for body to be available
      if (document.body) {
        document.body.insertBefore(noscript, document.body.firstChild);
      } else {
        document.addEventListener('DOMContentLoaded', () => {
          document.body.insertBefore(noscript, document.body.firstChild);
        });
      }
    });

    // Add helper methods to Vue instance
    app.config.globalProperties.$gtm = {
      /**
       * Push data to dataLayer
       * @param data - Data to push to dataLayer
       */
      push(data: any): void {
        window.dataLayer.push(data);
      },

      /**
       * Track page view
       * @param pageData - Page data to track
       */
      trackPage(pageData: { page?: string; title?: string; [key: string]: any }): void {
        if (store) {
          if (accountUtils.isLogin()) {
            const currentCareerId = store.getters['careerId/careerId'];
            if (currentCareerId) {
              pageData.career_id = currentCareerId;
            } else {
              pageData.career_id = undefined;
            }
          } else {
            pageData.career_id = undefined;
          }
        }
        window.dataLayer.push({
          event: 'pageview',
          page: pageData.page || window.location.pathname,
          title: pageData.title || document.title,
          ...pageData
        });
      },

      /**
       * Track event
       * @param eventData - Event data to track
       */
      trackEvent(eventData: { event: string; category?: string; action?: string; label?: string; value?: number; [key: string]: any }): void {
        if (store) {
          const currentCareerId = store.getters['careerId/careerId'];
          if (currentCareerId) {
            eventData.career_id = currentCareerId;
          }
        }
        window.dataLayer.push({
          ...eventData
        });
      },

      /**
       * Remove career_id after logout
       */
      resetCareerId(): void {
        window.dataLayer.push({
          career_id: undefined
        });
      }
    };
  }
};